import { render, staticRenderFns } from "./TiBancoCiss.vue?vue&type=template&id=6ce936ba"
import script from "./TiBancoCiss.vue?vue&type=script&lang=js"
export * from "./TiBancoCiss.vue?vue&type=script&lang=js"
import style0 from "./TiBancoCiss.vue?vue&type=style&index=0&id=6ce936ba&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports